<template>
  <div class="loading">
    <van-loading color="#888" vertical>正在加载</van-loading>
  </div>
</template>

<script>
import Vue from "vue";
import { Loading } from "vant";

Vue.use(Loading);

export default {
  name: "LOADING",
  data() {
    return {};
  },
};
</script>
<style scoped>
.loading {
  position: fixed;
  z-index: 999999999;
  width: 100%;
  height: 100vh;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
}
</style>
